// extracted by css-extract-rspack-plugin
export default {"container":"container-SwXyac","header":"header-tesTXU","testTitle":"testTitle-FvF0mW","textarea":"textarea-zLL6U4","footer":"footer-BHUTl1"};